// Versão do app - gerado automaticamente
export const APP_VERSION = '5.24'
export const BUILD_DATE = '08/02/2026, 01:50'
